﻿<template>
    <div class="notice-download">
        <div class="task-section">
            <div class="section-header">
                <h3 class="section-title">通知书下载任务列表</h3>
            </div>
            <div class="task-table">
                <el-table 
                    :data="taskList" 
                    border 
                    stripe
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                    empty-text="暂无任务">
                    
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="L_Title" label="任务标题" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="L_AddTime" label="创建时间" width="160" align="center">
                        <template slot-scope="{ row }">
                            {{ GetDateTimeString(row.L_AddTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="L_Field4" label="任务状态" width="200" align="center">
                        <template slot-scope="{ row }">
                            <el-tooltip v-if="isRunning(row.L_Field4)" :content="row.L_Field4" placement="top">
                                <el-progress :percentage="getPercent(row.L_Field4)" :text-inside="true" :stroke-width="16" class="status-progress"></el-progress>
                            </el-tooltip>
                            <el-tag v-else-if="row.L_Field4 === '生成完毕'" type="success" size="small">生成完毕</el-tag>
                            <el-tag v-else-if="isWaiting(row.L_Field4)" type="info" size="small">{{ row.L_Field4 || '等待处理' }}</el-tag>
                            <el-tag v-else type="danger" size="small">失败</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="L_Field3" label="解压密码" width="100" align="center"></el-table-column>
                    <el-table-column label="操作" width="260" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button 
                                v-if="row.L_Field3 && row.L_Field1" 
                                type="text" 
                                size="small" 
                                @click="handleDownload(row)">
                                <i class="el-icon-download"></i> 下载
                            </el-button>

                            <el-button 
                                type="text" 
                                size="small" 
                                @click="handleDelete(row)">
                                <i class="el-icon-delete"></i> 删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="task-pagination-container">
                <el-pagination
                    @size-change="handleTaskSizeChange"
                    @current-change="handleTaskCurrentChange"
                    :current-page="taskPageInfo.CurPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="taskPageInfo.RecordCountOfPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="taskPageInfo.RecordCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'NoticeDownload',
        data: function () {
            return {
                taskList: [],
                taskPageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                pollTimer: null,
                lastPollTime: 0,
                pollInterval: 5000
            }
        },
        methods: {
            LoadTaskList: function (pageIdx, pageCount, silent) {
                var that = this;
                var api_name = '/Notice/GetNoticeTaskList';
                var url = TYBM_Env.GetApiUrl(api_name);
                var options = silent ? { hide_tip: true } : { loading_msg: '正在加载任务列表' };
                
                var currentPage = pageIdx || that.taskPageInfo.CurPage;
                var currentCount = pageCount || that.taskPageInfo.RecordCountOfPage;
                
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, currentPage, currentCount), options)
                    .then(result => {
                        that.taskPageInfo = result.data.PageInfo;
                        that.taskList = result.data.List;
                        if (!silent) {
                            that.checkPolling();
                        }
                    }).catch(() => { });
            },
            handleTaskSizeChange(val) {
                this.taskPageInfo.RecordCountOfPage = val;
                this.LoadTaskList(1, val);
            },
            handleTaskCurrentChange(val) {
                this.LoadTaskList(val, this.taskPageInfo.RecordCountOfPage);
            },
            isRunning: function (status) {
                return !!status && status.indexOf('处理中') >= 0;
            },
            isWaiting: function (status) {
                return !status || status === '等待处理';
            },
            getPercent: function (status) {
                var m = /(\d+)\s*\/\s*(\d+)/.exec(status || '');
                if (m) {
                    var done = parseInt(m[1], 10);
                    var total = parseInt(m[2], 10);
                    if (total > 0) {
                        return Math.min(100, Math.floor(done * 100 / total));
                    }
                }
                return 0;
            },
            GetDateTimeString: function (date) {
                return TYBM_Tools.FormatDate('yyyy-MM-dd HH:mm:ss', new Date(date));
            },
            handleDownload: function (row) {
                if (!row.L_Field1) {
                    this.$message.warning('文件路径不存在');
                    return;
                }
                var downloadUrl = TYBM_Env.ServerHost + row.L_Field1;
                window.open(downloadUrl, '_blank');
                this.$message.success('已开始下载，请等待浏览器提示');
            },

            handleDelete: function (row) {
                var that = this;
                that.$confirm('确定要删除此任务记录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var api_name = '/Notice/DeleteNoticeTask';
                    var url = TYBM_Env.GetApiUrl(api_name);
                    TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify({ L_SN: row.L_SN }) }, { loading_msg: '正在删除...' })
                        .then(result => {
                            if (result.code === 'ok') {
                                that.$message.success('删除成功');
                                that.LoadTaskList();
                            } else {
                                that.$message.error(result.errmsg || result.msg || '删除失败');
                            }
                        })
                        .catch(() => {
                            that.$message.error('删除失败');
                        });
                }).catch(() => { });
            },
            hasRunningTask: function () {
                var that = this;
                return that.taskList.some(function (row) {
                    return that.isRunning(row.L_Field4) || that.isWaiting(row.L_Field4);
                });
            },
            checkPolling: function () {
                if (this.hasRunningTask()) {
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            },
            startPolling: function () {
                var that = this;
                if (that.pollTimer) {
                    return;
                }
                that.pollTimer = setInterval(function () {
                    var now = Date.now();
                    if (now - that.lastPollTime >= that.pollInterval) {
                        that.lastPollTime = now;
                        that.LoadTaskList(that.taskPageInfo.CurPage, that.taskPageInfo.RecordCountOfPage, true);
                    }
                }, that.pollInterval);
            },
            stopPolling: function () {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        created: function () {
            this.LoadTaskList();
        },
        beforeDestroy: function () {
            this.stopPolling();
        }
    }
</script>

<style scoped>
    .notice-download {
        padding: 20px;
        background-color: #f5f7fa;
    }

    .task-section {
        margin-top: 20px;
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

    .section-title {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }

    .task-table {
        background: white;
        border-radius: 8px;
        overflow-x: auto;
    }

    .task-table >>> .el-table {
        font-size: 13px;
    }

    .task-table >>> .el-table th,
    .task-table >>> .el-table td {
        padding: 0 !important;
        height: 40px !important;
    }

    .task-table >>> .el-table th {
        background-color: #f5f7fa !important;
        color: #606266;
        font-weight: 600;
    }

    .task-table >>> .el-table__row {
        height: 40px !important;
    }

    .task-table >>> .el-table .cell {
        padding: 0 8px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        line-height: 40px !important;
    }

    .task-pagination-container {
        margin-top: 15px;
        display: flex;
        justify-content: center;
    }

    .task-table >>> .el-button--text {
        color: #409EFF;
        padding: 0;
    }

    .status-progress {
        width: 90%;
        margin: 0 auto;
    }
</style>